/**
 * Geocoding Constants
 *
 * Constants and error messages for geocoding functionality.
 */

/**
 * Geocoding configuration constants
 */
export const GEOCODING_CONSTANTS = {
  /** Minimum query length for search */
  MIN_QUERY_LENGTH: 3,
  /** Maximum query length for search */
  MAX_QUERY_LENGTH: 200,
  /** Default search limit */
  DEFAULT_SEARCH_LIMIT: 10,
  /** Default timeout for requests (ms) */
  DEFAULT_TIMEOUT_MS: 5000,
  /** Default rate limit delay (ms) */
  DEFAULT_RATE_LIMIT_DELAY_MS: 1000,
  /** Maximum retries for failed requests */
  MAX_RETRIES: 3,
  /** Debounce delay for search input (ms) */
  SEARCH_DEBOUNCE_DELAY_MS: 300,
  /** Debounce delay for reverse-geocoding a moving map center (ms) */
  REVERSE_GEOCODE_DEBOUNCE_MS: 500,
} as const;
